import { render, staticRenderFns } from "./vendorPaymentComponent.vue?vue&type=template&id=5e964970&"
import script from "./vendorPaymentComponent.vue?vue&type=script&lang=js&"
export * from "./vendorPaymentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports